export const APP = 'FactorioLab';
export const MIN_LINK_VALUE = 1e-10;
